import {Auth0Provider} from '@auth0/auth0-react';
import {Configuration, PublicClientApplication} from '@azure/msal-browser';
import {MsalProvider} from '@azure/msal-react';
import {QueryClient, QueryClientProvider} from '@tanstack/react-query';
import {createBrowserHistory} from 'history';
import React from 'react';
import ReactDOM from 'react-dom/client';
import 'react-toastify/dist/ReactToastify.css';
import {App} from './components/App';
import {config} from './lib/env';
import reportWebVitals from './reportWebVitals';
import './styles/global.css';

const history = createBrowserHistory();

// Auth0 configuration
const auth0Config = {
    auth: {
        domain: config.authentication.auth0domain || '',
        clientId: config.authentication.auth0ClientId || '',
        redirectUri: config.authentication.redirectUri,
        postLogoutRedirectUri: config.authentication.redirectUri || 'https://www.cohedron.nl',
    },
};

const msalConfig: Configuration = {
    auth: {
        authority: config.authentication.msalAuthority,
        clientId: config.authentication.msalClientId || '',
        postLogoutRedirectUri: config.authentication.redirectUri,
    },
};

const msalPublicClientApplication = new PublicClientApplication(msalConfig);
const onRedirectCallback = (appState: any) => {
    const to = appState && appState.returnTo ? appState.returnTo : window.location.pathname;
    console.info('login redirect to', to);
    history.push(to);
};

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            refetchOnWindowFocus: false,
            retry: 1,
        },
    },
});

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
    <React.StrictMode>
        <MsalProvider instance={msalPublicClientApplication}>
            <Auth0Provider
                clientId={auth0Config.auth.clientId}
                cacheLocation={'localstorage'}
                onRedirectCallback={onRedirectCallback}
                domain={auth0Config.auth.domain}
                authorizationParams={{redirect_uri: window.location.origin, audience: config.authentication.audience}}
            >
                <QueryClientProvider client={queryClient}>
                    <App/>
                </QueryClientProvider>
            </Auth0Provider>
        </MsalProvider>
    </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
